import {Request} from "citrus.plugins.request";

const BULLETS_REST_ACTION_PREFIX = "citrus:restsale.api.bullets.";
const BULLETS_METHOD_FOR_CATALOG = "bulletsForCatalog";
const BULLETS_METHOD_FOR_ELEMENT = "bulletsForElement";
const BULLETS_ELEMENT_PROPERTY = "bullets";

let BulletsRestClient = {
	data() {
		return {
			bulletsRequest: new Request()
		}
	},

	methods: {
		getBulletsForElement(id, propertyName) {
			this.bulletsRequest.setModeModule();
			return this.bulletsRequest
				.setAction(BULLETS_REST_ACTION_PREFIX + BULLETS_METHOD_FOR_ELEMENT)
				.setData({
					id: id,
					propertyName: propertyName
				})
				.send();
		},

		getBulletsForCatalog(ids, propertyName) {
			this.bulletsRequest.setModeModule();
			return this.bulletsRequest
				.setAction(BULLETS_REST_ACTION_PREFIX + BULLETS_METHOD_FOR_CATALOG)
				.setData({
					ids: ids,
					propertyName: propertyName
				})
				.send();
		},
		getBulletsInfo(products, propertyName) {
			let ids = [];
			for (let i in products) {
				ids.push(products[i].id);
			}

			this.getBulletsForCatalog(ids, propertyName).then(result => this.productBulletsUpdate(products, result));
		},
		productBulletsUpdate(products, result) {
			for (let i in products) {
				this.$set(products[i], BULLETS_ELEMENT_PROPERTY, result[products[i].id]);
			}
		},
	}
}
export {BulletsRestClient};
export default {BulletsRestClient};